var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{},[_c('datatable-approve-requests',{ref:"datatable-approve-requests",attrs:{"title":"Solicitudes de Aprobación"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }